import styled from 'styled-components';
import { Button } from '../../utils/Button/Button';

export const Form = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    width: unset;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.4rem;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 4rem;
`;

export const CancelButton = styled(Button)`
  border: 1px solid #d92d20;
  background: #fff;
  width: unset;
  padding-inline: 2.4rem;
  color: #d92d20;
`;

export const DeleteButton = styled.button`
  border: none;
  outline: none;
  background: transparent;
  width: unset;
  padding: 1.2rem;
  color: #ba1619;
  font-size: 1.6rem;
  font-weight: 500;
  letter-spacing: -0.42px;
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const SubmitButton = styled(Button)`
  width: 16rem;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const ButtonWrapperRow = styled.div`
  display: flex;
  gap: 1.2rem;
`;
